// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file license_type.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file license_type.proto.
 */
export const file_license_type: GenFile = /*@__PURE__*/
  fileDesc("ChJsaWNlbnNlX3R5cGUucHJvdG8SBmRvbWFpbiqEAwoLTGljZW5zZVR5cGUSGAoUTElDRU5TRV9UWVBFX1VOS05PV04QABIVChFMSUNFTlNFX1RZUEVfTk9ORRABEh8KG0xJQ0VOU0VfVFlQRV9DT1VQT05fQVBQU1VNTxACEhcKE0xJQ0VOU0VfVFlQRV9QQURETEUQAxIaChZMSUNFTlNFX1RZUEVfTk9OUFJPRklUEAQSGQoVTElDRU5TRV9UWVBFX0NPTlRSQUNUEAUSFwoTTElDRU5TRV9UWVBFX0NVU1RPTRAGEhgKFExJQ0VOU0VfVFlQRV9WSUFfTVNQEAcSGAoUTElDRU5TRV9UWVBFX0VYQU1QTEUQCBIiCh5MSUNFTlNFX1RZUEVfQ09VUE9OX1BSSU1FX0NMVUIQCRIeChpMSUNFTlNFX1RZUEVfQ09VUE9OX0ZBTUlMWRAKEiAKHExJQ0VOU0VfVFlQRV9WSUFfRElTVFJJQlVUT1IQCxIgChxMSUNFTlNFX1RZUEVfRElSRUNUX1JFU0VMTEVSEAxCMFouZ2l0bGFiLmNvbS9jb3RlY2hkZS9tb25vcmVwby9iYWNrZW5kL2RvbWFpbi9wYmIGcHJvdG8z");

/**
 * @generated from enum domain.LicenseType
 */
export enum LicenseType {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: LICENSE_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: LICENSE_TYPE_NONE = 1;
   */
  NONE = 1,

  /**
   * @generated from enum value: LICENSE_TYPE_COUPON_APPSUMO = 2;
   */
  COUPON_APPSUMO = 2,

  /**
   * @generated from enum value: LICENSE_TYPE_PADDLE = 3;
   */
  PADDLE = 3,

  /**
   * @generated from enum value: LICENSE_TYPE_NONPROFIT = 4;
   */
  NONPROFIT = 4,

  /**
   * @generated from enum value: LICENSE_TYPE_CONTRACT = 5;
   */
  CONTRACT = 5,

  /**
   * @generated from enum value: LICENSE_TYPE_CUSTOM = 6;
   */
  CUSTOM = 6,

  /**
   * @generated from enum value: LICENSE_TYPE_VIA_MSP = 7;
   */
  VIA_MSP = 7,

  /**
   * @generated from enum value: LICENSE_TYPE_EXAMPLE = 8;
   */
  EXAMPLE = 8,

  /**
   * @generated from enum value: LICENSE_TYPE_COUPON_PRIME_CLUB = 9;
   */
  COUPON_PRIME_CLUB = 9,

  /**
   * @generated from enum value: LICENSE_TYPE_COUPON_FAMILY = 10;
   */
  COUPON_FAMILY = 10,

  /**
   * @generated from enum value: LICENSE_TYPE_VIA_DISTRIBUTOR = 11;
   */
  VIA_DISTRIBUTOR = 11,

  /**
   * @generated from enum value: LICENSE_TYPE_DIRECT_RESELLER = 12;
   */
  DIRECT_RESELLER = 12,
}

/**
 * Describes the enum domain.LicenseType.
 */
export const LicenseTypeSchema: GenEnum<LicenseType> = /*@__PURE__*/
  enumDesc(file_license_type, 0);

